module.exports = __webpack_public_path__ + "static/media/shop.72540bbd.svg";